<input type="text" [(ngModel)]="time" [disabled]="disabled"

[matMenuTriggerFor]="menuTime" readonly (menuOpened)="isOpen=true" (menuClosed)="isOpen=false" [class.open]="isOpen"/>

<mat-menu #menuTime="matMenu" class="time-menu" backdropClass="time-backdrop">
    <div fxLayout="row" class="fxLayout">
        <div>
            <button (click)="HoursScroll($event,-20)" mat-menu-item><i class="fal fa-angle-up"></i></button>
        </div>
        <div>
            <button (click)="MinutesScroll($event,-20)" mat-menu-item><i class="fal fa-angle-up"></i> </button>
        </div>
        <div class="list" #hours>
            <button *ngFor="let h of hoursArr" (click)="setHours($event,h)" mat-menu-item>{{h}}</button>
        </div>
        <div class="list" #minutes>
            <button *ngFor="let m of minutesArr" (click)="setMinutes($event,m)" mat-menu-item>{{m}}</button>
        </div>
        <div>
            <button (click)="HoursScroll($event,20)" mat-menu-item><i class="fal fa-angle-down"></i></button>
        </div>
        <div>
            <button (click)="MinutesScroll($event,20)" mat-menu-item> <i class="fal fa-angle-down"></i> </button>
        </div>
    </div>
</mat-menu>